import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Eyebrow, Headline } from "@/components/Editorial";
import { FullPageLoader } from "@/components/Loader";
import TopWedge from "@/components/TopWedge";
import { apiGet } from "@/lib/api";
import { C, PROGRAM_META, metaForSlug } from "@/lib/brand";

export default function Programs() {
  const [programs, setPrograms] = useState(null);

  useEffect(() => {
    apiGet("/consumer/programs", { auth: false })
      .then(setPrograms)
      .catch(() => setPrograms([]));
  }, []);

  if (programs === null) return <FullPageLoader />;

  // Build slug→program map
  const bySlug = new Map((programs || []).map((p) => [(p.slug || "").toLowerCase(), p]));

  return (
    <div data-testid="programs-page" style={{ background: C.cream, paddingBottom: 80 }}>
      <section style={{ background: C.ink, color: C.cream, padding: "64px 24px 88px" }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <Eyebrow color={C.peach}>★ THE EDIT</Eyebrow>
          <Headline before="BROWSE" italic="the edit." color={C.cream} italicColor={C.peach} size={80} className="mt-4" />
          <p style={{ marginTop: 22, fontSize: 16, color: "rgba(250,246,240,0.7)", lineHeight: 1.55, maxWidth: 540 }}>
            Six programs. Each one is built on real research and supervised by licensed physicians.
          </p>
        </div>
      </section>

      <section style={{ padding: "52px 16px 64px", position: "relative", background: C.cream }}>
        <TopWedge color={C.ink} dir="right" />
        <div style={{ maxWidth: 800, margin: "0 auto", display: "flex", flexDirection: "column", gap: 20, position: "relative", zIndex: 2 }}>
          {PROGRAM_META.map((meta, i) => {
            const program = Array.from(bySlug.values()).find((p) => meta.slugMatch.some((x) => (p.slug || "").toLowerCase().includes(x)));
            const isActive = !!program;
            const slug = program?.slug || "";
            const flip = i % 2 === 1;
            const Card = (
              <div
                style={{
                  background: meta.color,
                  color: meta.dark,
                  padding: "48px 36px 56px",
                  position: "relative",
                  overflow: "hidden",
                  display: "block",
                  cursor: isActive ? "pointer" : "default",
                  opacity: isActive ? 1 : 0.65,
                }}
              >
                <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: "0.2em", opacity: 0.6 }}>
                  CATEGORY {meta.num}
                </div>
                <div style={{ marginTop: 14, fontSize: 44, fontWeight: 800, letterSpacing: "-0.03em", lineHeight: 0.95 }}>
                  {meta.t}
                  {meta.t2 && (<><br />{meta.t2}</>)}
                </div>
                <div style={{ marginTop: 14, fontFamily: '"Instrument Serif", serif', fontStyle: "italic", fontSize: 22 }}>
                  "{meta.q}"
                </div>
                {program?.description && (
                  <p style={{ marginTop: 16, fontSize: 14, lineHeight: 1.6, opacity: 0.85, maxWidth: 480 }}>
                    {program.description}
                  </p>
                )}
                <div style={{ marginTop: 28, fontSize: 11, fontWeight: 800, letterSpacing: "0.2em" }}>
                  {isActive ? "EXPLORE →" : "COMING SOON"}
                </div>
              </div>
            );

            if (isActive) {
              return (
                <Link key={meta.num} to={`/app/programs/${slug}`} data-testid={`browse-card-${meta.num}`} style={{ textDecoration: "none" }}>
                  {Card}
                </Link>
              );
            }
            return <div key={meta.num} data-testid={`browse-card-${meta.num}`}>{Card}</div>;
          })}
        </div>
      </section>
    </div>
  );
}
